import React, { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";

import PageLayout from "../../../_layout/PageLayout";
import {
  ActionsSection,
  ButtonsSection,
  DataSection,
  SubSection,
  DescriptionSection,
} from "../../../../components/data-components/sections/DataSections";
import { ViewOrganizationInfo } from "../../../../services/authorization/Permissions";
import EditButton from "../../../../components/buttons/edit-button/EditButton";
import {
  DisplayEmail,
  DisplayGeneralManagerFirstName,
  DisplayGeneralManagerLastName,
  DisplayPhone,
  DisplayWebsiteURL,
} from "../../../users/components/DataComponents";
import DisplayDateCreated from "../../../../components/data-components/DisplayDateCreated";
import DisplayCreatedBy from "../../../../components/data-components/DisplayCreatedBy";
import {
  DisplayOrganizationName,
  DisplayOrganizationContactName,
  DisplayOrganizationCountry,
  DisplayOrganizationAddress,
  DisplayOrganizationHouseNumber,
  DisplayOrganizationZip,
  DisplayOrganizationCity,
  DisplayOrganizationState,
  DisplayOrganizationVat,
} from "../components/DataComponents";
import { SettingsMenuItemsModel } from "../.././SettingsMenuItems";
import { CurrentOrganizationStorageModel } from "../../../../services/organization/CurrentOrganizationStorage";
import { api } from "../../../../services/api/ApiService";

export default observer(() => {
  const history = useHistory();

  const [currentOrganizationStorage] = useState(() =>
    CurrentOrganizationStorageModel.create({}, { api })
  );

  const menuItems = useMemo(() => {
    const settingsMenuItems = SettingsMenuItemsModel.create({});

    return {
      staticItems: settingsMenuItems.getStaticItems(),
    };
  }, []);

  const handleEditClick = useCallback(() => history.push(`organization-details/edit`), [history]);

  return (
    <div>
      <PageLayout
        id="view-organization-details"
        accessWithOneOfThePermissions={[ViewOrganizationInfo]}
        titleKey="ViewOrganization.title"
        menuItems={menuItems}
        isLoading={currentOrganizationStorage.isLoading}
      >
        <ActionsSection>
          <ButtonsSection>
            <EditButton onClick={handleEditClick} />
          </ButtonsSection>
        </ActionsSection>
        <DataSection labelKey="general.organization.details">
          <SubSection hideRightBorder>
            <DisplayOrganizationName name={currentOrganizationStorage.organization.name} />
            <DisplayOrganizationCountry
              code={currentOrganizationStorage.organization.countryCode}
            />
            <DisplayOrganizationAddress address={currentOrganizationStorage.organization.address} />
            <DisplayOrganizationHouseNumber
              number={currentOrganizationStorage.organization.addressNumber}
            />
            <DisplayOrganizationZip zip={currentOrganizationStorage.organization.zip} />
            <DisplayOrganizationCity city={currentOrganizationStorage.organization.city} />
            <DisplayOrganizationState state={currentOrganizationStorage.organization.state} />
            <DisplayOrganizationVat vat={currentOrganizationStorage.organization.vat} />
          </SubSection>
          <SubSection>
            <DisplayGeneralManagerFirstName
              name={currentOrganizationStorage.organization.generalManagerFirstName}
            />
            <DisplayGeneralManagerLastName
              name={currentOrganizationStorage.organization.generalManagerLastName}
            />
            <DisplayPhone inOrganization phone={currentOrganizationStorage.organization.phone} />
            <DisplayWebsiteURL websiteURL={currentOrganizationStorage.organization.websiteURL} />
          </SubSection>
          <SubSection>
            <DisplayOrganizationContactName
              contactName={currentOrganizationStorage.organization.contact.name}
            />
            <DisplayEmail email={currentOrganizationStorage.organization.contact.email} />
            <DisplayDateCreated date={currentOrganizationStorage.organization.created} />
            <DisplayCreatedBy createdBy={currentOrganizationStorage.organization.createdBy.name} />
          </SubSection>
        </DataSection>
        <DescriptionSection description={currentOrganizationStorage.organization.description} />
      </PageLayout>
    </div>
  );
});
